module.exports = __webpack_public_path__ + "static/media/Help.57403fa9.svg";